import { Route, Routes } from 'react-router-dom'
import VisitorLogPage from './Page'

export default function VisitorLog() {
  return (
    <Routes>
      <Route path="/" element={<VisitorLogPage />} />
      <Route path="/:id" element={<VisitorLogPage />} />
    </Routes>
  )
}